<template>
  <v-container :class="containerClass" fluid>
    <student-form mode="view" :student="student.data" @cancel="onCancel">
      <template #header>
        <div class="d-flex align-center">
          <v-btn
            icon
            color="primary"
            class="mr-2"
            :href="$route('students.index')"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <h2>View {{ student.data.name }}</h2>
        </div>
      </template>
    </student-form>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import StudentForm from '@components/Student/Form'
export default {
  components: {
    StudentForm,
  },
  layout: LayoutDashboard,
  props: {
    student: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onCancel() {
      window.location.href = this.$route('students.index')
    },
  },
}
</script>
